import React from 'react';
import {TableRow, TableHead} from '@material-ui/core';
import {curry} from 'ramda';
import HeaderCell from './HeaderCell';

export const getHeaderCell = curry((rowHeight, column) => {
    return (
        <HeaderCell
            key={column.dataKey}
            column={column}
            rowHeight={rowHeight}
        />
    );
});

export interface HeaderProps {
    columns: any[];
    rowHeight: number;
}

const Header = ({columns, rowHeight}: HeaderProps) => {
    const withRowHeight = getHeaderCell(rowHeight);
    const headers = columns.map(withRowHeight);

    return (
        <TableHead
            component="div"
        >
            <TableRow
                component="div"
                className="row"
            >
                {headers}
            </TableRow>
        </TableHead>
    );
};

export default Header;
